import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const categoryColors: Record<string, string> = {
    funny: "bg-accent-100 text-accent-700",
    cute: "bg-primary-100 text-primary-700",
    story: "bg-secondary-100 text-secondary-700",
    healing: "bg-accent-100 text-accent-700",
    daily: "bg-secondary-100 text-secondary-700",
  };

  const catColor =
    categoryColors[article.categorySlug] || "bg-primary-100 text-primary-700";

  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative w-full aspect-[4/3] overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          title={`${article.title} - 打屁股漫画精选合集`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {article.hot && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
            热门
          </span>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${catColor}`}
          >
            {article.category}
          </span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            {article.readTime} 分钟阅读
          </span>
        </div>
        <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
          {article.description}
        </p>
        <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200/60">
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            {article.publishDate}
          </span>
          <span className="flex items-center gap-1 text-xs text-foreground-400 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {article.views.toLocaleString()}
          </span>
        </div>
      </div>
    </Link>
  );
}